export const ANIMATION_TIME = 300
